/*
 * @Description: 
 * @Version: 1.0
 * @Autor: zhangle
 * @Date: 2022-04-13 10:45:19
 * @LastEditors: zhangle
 * @LastEditTime: 2023-10-12 14:56:04
 */
import { draftCountApi } from '@/api/copyright/draft'
import { dramaCountApi } from '@/api/copyright/drama'
let State = {
    keepAliveArray: [],
    keepAliveRefresh: false,
    visualDeviceType: '', // 视觉上的设备类型
    draftBoxCount: 0,
    dramaBoxCount: 0,
    parentIframe: null, // 父级iframe
}
let MutAtions = {
    addKeepAliveArray (state, data) {
        if (state.keepAliveArray.indexOf(data) === -1) {
            state.keepAliveArray.push(data)
        }
    },
    deleteKeepAliveArray (state, data) {
        let index = state.keepAliveArray.indexOf(data)
        if (index > -1) {
            state.keepAliveArray.splice(index, 1)
        }
    },
    setKeepAliveRefresh (state, data) {
        state.keepAliveRefresh = data
    },
    setVisualDeviceType (state, data) {
        state.visualDeviceType = data
    },
    updateDraftBoxCount(state, count) {
        state.draftBoxCount = count
    },
    updateDramaBoxCount(state, count) {
        state.dramaBoxCount = count
    },
    setParentIframe (state, data) {
        if (data) {
            state.parentIframe = data
        } else {
            let ua=navigator.userAgent
            let isAndroid=(ua.indexOf("Android") > -1 || ua.indexOf("Linux") > -1) && ua.indexOf("ZGSDK") > -1;
            let isIOS = (!!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) && ua.indexOf("ZGSDK") > -1;
            //let isHarmonyosNext = ua.indexOf('ArkWeb') > -1 && ua.indexOf("ZGSDK") > -1
            let isHarmonyosNext = window.nativeMethod && window.nativeMethod.isHarmonyosNext()
            let isWeixn=ua.toLowerCase().match(/MicroMessenger/i) == "micromessenger"? true : false;
            if (isAndroid) {
                state.parentIframe = 'ANDROID-RIGHTS'
            } else if (isIOS) {
                state.parentIframe = 'IOS-RIGHTS'
            } else if (isHarmonyosNext) {
                state.parentIframe = 'HARMONYOSNEXT-RIGHTS'
            } else if (isWeixn) {
                state.parentIframe = 'WEIXIN'
            }
        }
    },
}
let Actions = {
    updateDraftBoxCount({ commit }) {
        return new Promise((resolve, reject) => {
            draftCountApi({ type: -1 }).then(res => {
                let count = res.data && res.data.num ? res.data.num : 0
                commit('updateDraftBoxCount', count)
                resolve(count)
            }).catch(() => {
                reject()
            })
            
        })
    },
    updateDramaBoxCount({ commit }) {
        return new Promise((resolve, reject) => {
            dramaCountApi({ type: -1 }).then(res => {
                let count = res.data && res.data.num ? res.data.num : 0
                commit('updateDramaBoxCount', count)
                resolve(count)
            }).catch(() => {
                reject()
            })

        })
    }
}
export default {
    namespaced: true,
    strict: true,
    state: State,
    // getters: Getters,
    mutations: MutAtions,
    actions: Actions
};
